module.exports = __webpack_public_path__ + "img/Ventuar_Metal Battleaxe.ba2c1548.png";